import { defineComponent as _defineComponent } from 'vue'
import { LegacyPhotoValidation } from '@/ui/components/inspectionReport/legacyTypes';
  import { computed } from 'vue';
  import { t } from '@/ui/i18n/i18n';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PhotoValidation',
  props: {
    validation: {
      type: Object as () => LegacyPhotoValidation,
      required: true,
    },
    criteria: {
      type: String as () => string | null | undefined,
      required: false,
      default: null,
    },
  },
  setup(__props) {

const props = __props;

  

  const result = computed(() => props.validation.result
    ? t('inspection-report.photo-validation.positive')
    : t('inspection-report.photo-validation.negative'));

  const resultClass = computed(() => props.validation.result
    ? 'inspection-report__validation-result--positive'
    : 'inspection-report__validation-result--negative');

  const confidencePercent = computed(() => Math.round((props.validation.confidence || 0) * 100));

return { __sfc: true,props, result, resultClass, confidencePercent }
}

})